import React from 'react';

export default function IProfile(props) {
  return (
    <svg width='30' height='33' viewBox='0 0 30 33' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M15.1198 17.4526C19.6939 17.4526 23.6498 14.1123 23.6498 9.70264C23.6498 5.29299 19.6939 1.95264 15.1198 1.95264C10.5458 1.95264 6.58984 5.29299 6.58984 9.70264C6.58984 14.1123 10.5458 17.4526 15.1198 17.4526Z'
        stroke='#020000'
        strokeWidth='2.5'
      />
      <path
        d='M8.91065 19.8716C5.35292 19.2713 2.10938 22.0135 2.10938 25.6215C2.10938 28.8419 4.72007 31.4526 7.94053 31.4526H22.3698C25.5507 31.4526 28.1294 28.874 28.1294 25.693C28.1294 22.0628 24.8118 19.3379 21.2507 20.0432L16.8965 20.9056C16.3316 21.0174 15.7511 21.0257 15.1834 20.9299L8.91065 19.8716Z'
        stroke='#020000'
        strokeWidth='2.5'
      />
    </svg>
  );
}
